<div class="notifications-panel">
  <div class="panel-header">
    <p class="header-title">
      {{ "App.Notifications" | translate }}
    </p>
    <button
      type="button"
      class="close-icon"
      [attr.aria-label]="'NotificationsPanel.CloseNotifications' | translate"
      (click)="closePanel()">
      <icon-display [iconName]="'close'" />
    </button>
  </div>
  <div class="notifications-list">
    @for (notification of notifications; track notification) {
      <lc-notification-item
        [notification]="notification"
        (click)="markNotificationAsRead(notification)"
        (keydown.enter)="markNotificationAsRead(notification)" />
    }
  </div>
</div>
